import { Grid, SxProps, Typography } from "@mui/material";
import React from "react";
import { EquipmentAdjustment } from "../../Objects/EquipmentAdjustment";

export interface EquipmentAdjustmentTotalProps {
    equipmentAdjustmentList: EquipmentAdjustment[]
    sx?: SxProps
}

const EquipmentAdjustmentTotal: React.FC<EquipmentAdjustmentTotalProps> = ({
    equipmentAdjustmentList,
    sx,
}) => {

    /**
     * View
     */
    return (
        <Grid container
            sx={sx}
        >
            <Grid item
                xs={6}
            >
                <Typography>機材レンタル代合計</Typography>
            </Grid>
            <Grid item
                xs={6}
            >
                <Typography align="right">{equipmentAdjustmentList.reduce((sum: number, item: EquipmentAdjustment) => {
                    return sum + item.charge
                }, 0).toLocaleString()}円</Typography>
            </Grid>
        </Grid>
    )
}

export default EquipmentAdjustmentTotal